import type { Branding } from "@devengo/shared";

export type TenantBranding = Branding & { slug: string };

/**
 * Article VII: the studio's identity is data. Fetched before the first render (main.tsx) and
 * applied as CSS variables, so no component ever knows a color.
 */
export async function loadBranding(): Promise<TenantBranding | { error: string }> {
  const response = await fetch("/api/tenant/branding", { credentials: "same-origin" });
  if (!response.ok) {
    // The API's own Spanish message: unknown address vs. a suspended studio read differently.
    const body = (await response.json().catch(() => null)) as {
      error?: { message?: string };
    } | null;
    return { error: body?.error?.message ?? "No encontramos ningún estudio en esta dirección." };
  }
  return (await response.json()) as TenantBranding;
}

export function applyBranding(branding: TenantBranding): void {
  const root = document.documentElement.style;
  root.setProperty("--color-brand-primary", branding.primaryColor);
  root.setProperty(
    "--color-brand-secondary",
    `color-mix(in oklch, ${branding.primaryColor} 65%, white)`,
  );
  root.setProperty("--color-brand-tint", `color-mix(in oklch, ${branding.primaryColor} 8%, white)`);
  document.title = branding.displayName;
}
